import { InjectionToken } from '@angular/core';

export const COMPONENT_MODE: InjectionToken<boolean> = new InjectionToken<boolean>('COMPONENT_MODE');
